import { CloseIcon } from 'assets/icons';
import { Globals } from 'utils';
import React from 'react';

interface ModalViewPlanProps {
  plan?: any
  onClose: () => void
  onEdit?: () => void
}

const ModalViewPlan = ({ plan, onClose, onEdit }: ModalViewPlanProps) => {
  return (
    <div>
      <p className="title">{ plan?.name }</p>
      <button className="close-btn" onClick={onClose}>
        <img src={CloseIcon} alt="Cerrar" />
      </button>

      <section className="head">
        <p className="price">
          { Globals.formatMiles(plan?.price_annual, !Number.isInteger(plan?.price_annual)).replace(' ','') }
        </p>
        <div className="actions">
          {onEdit && (
            <button onClick={onEdit}>
              <span>Editar</span>
            </button>
          )}
        </div>
      </section>

      <section className="body">
        <label>Tipo consultas</label>
        {plan?.types?.map((item: any, idx: number) => (
          <p
            key={`type-${idx}`}
            className="type"
            style={{ backgroundColor: item?.type?.color_2, border: `1px solid ${item?.type?.color_1}` }}
          >
            { item?.type?.name }
          </p>
        ))}

        <div className="specialties">
          <label>Especialidad</label>
          <label>Cantidad</label>
          {plan?.specialties?.map((item: any, index: number) => (
            <React.Fragment key={index}>
              <p>{ item?.specialty?.name }</p>
              <p>{ item?.uses_quantity }</p>
            </React.Fragment>
          ))}
        </div>
      </section>
    </div>
  );
}

export default ModalViewPlan;